import { useMemo } from 'react';
import { useAppContext } from '../../context/AppContext';
import { useSearchParams } from '../../hooks/useSearchParams';
import { useFilterConfig } from './useFilterConfig';
export function useAppliedFilters() {
  const params = useSearchParams();
  const filterConfig = useFilterConfig();
  const appContext = useAppContext();
  return useMemo(() => {
    const productType = params.get('productType', {
      allowedValues: ['APP', 'AGENT']
    });
    const filters = Object.values(filterConfig).filter(f => {
      if (!f) return false;

      // ensure product type matches (if specified)
      if (f.productType && f.productType !== productType) return false;

      // ensure filter is allowed for the current app context
      if (f.allowedAppContext && f.allowedAppContext !== appContext) return false;
      return true;
    });
    const appliedFilters = [];
    for (const filter of filters) {
      const paramValues = params.getList(filter.field);
      if (paramValues.length === 0) continue;
      appliedFilters.push(Object.assign({}, filter, {
        values: paramValues
      }));
    }
    return appliedFilters;
  }, [params, filterConfig, appContext]);
}